import { EmailContactData } from '../../../../../models/EmailContact';
import { ReplyRecipients } from '../../../../../models/Email';
import { MAX_OTHER_RECIPIENTS } from '../../../../../utils/replyRecipients';
import CopyContactIdButton from '../CopyContactIdButton/CopyContactIdButton';
import RecipientField from '../Recipients/RecipientField';
import { Box, Typography } from '@coolblue-development/freddy';

// Display-only label; the subject actually sent comes from replySubject in useSendEmail.
const NO_SUBJECT_LABEL = '(no subject)';

interface ReplyHeaderProps {
  data: EmailContactData;
  recipients: ReplyRecipients;
  onRecipientsChange: (recipients: ReplyRecipients) => void;
  areRecipientsDisabled?: boolean;
}

const ReplyHeader = ({
  data,
  recipients,
  onRecipientsChange,
  areRecipientsDisabled = false
}: ReplyHeaderProps): JSX.Element => {
  return (
    <Box
      sx={{
        border: '1px solid #DDDDDD',
        borderRadius: '4px 4px 0 0',
        padding: '12px'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
        data-testid="reply-header"
      >
        <Typography
          variant="h6"
          sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1, minWidth: 0 }}
          data-testid="reply-subject"
        >
          {data.subject ?? NO_SUBJECT_LABEL}
        </Typography>
        <CopyContactIdButton contactId={data.contactId} />
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px', marginTop: '8px' }}>
        <RecipientField
          label="To"
          addLabel="Add recipient"
          recipients={recipients.to}
          onChange={to => onRecipientsChange({ ...recipients, to })}
          maxRecipients={1}
          takenAddresses={recipients.otherRecipients}
          disabled={areRecipientsDisabled}
        />
        <RecipientField
          label="Other recipients"
          addLabel="Add Other recipients"
          recipients={recipients.otherRecipients}
          onChange={otherRecipients => onRecipientsChange({ ...recipients, otherRecipients })}
          maxRecipients={MAX_OTHER_RECIPIENTS}
          maxRecipientsMessage={`You can add up to ${MAX_OTHER_RECIPIENTS} other recipients`}
          takenAddresses={recipients.to}
          disabled={areRecipientsDisabled}
        />
      </Box>
    </Box>
  );
};

export default ReplyHeader;
